export const countryOptions = [
  { key: "US", label: "US" },
  { key: "Canada", label: "Canada" },
  { key: "UK", label: "UK" },
  { key: "Australia", label: "Australia" },
];
